import axios from "axios";
const jsonConfig = require("../../config.json");

const ResetAlert = async () => {
  try {
    const getAllResponse = await axios.delete(jsonConfig.apiUrl + "ResetAlert", {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default ResetAlert;
